<template>
  <div>
    <md-dialog
      :class="modal == 'true' ? 'md-dialog-modal' : 'md-dialog-modal-none'"
      :md-active.sync="showDialog"
      :md-click-outside-to-close="false"
      v-resize="onResize"
    >
      <md-dialog-title class="text-center">Secure ID Verification</md-dialog-title>
      <md-dialog-content>
        <h6>We are going to verify your identity</h6>
        <ul>
          <li>We will not share your ID documents with any other party.</li>
          <li>
            You can view our full privacy policy on our website, at
            <a href="https://www.SecureIDverify.com/privacy" target="_blank"
              >https://www.SecureIDverify.com/privacy</a
            >
            (will open in new tab)
          </li>
          <li>Please have your ID document ready</li>
        </ul>

        <md-dialog-actions>
          <md-progress-spinner
            v-if="showspinner"
            md-mode="indeterminate"
          ></md-progress-spinner>
          <md-button
            class="md-raised md-primary btn-element"
            @click="go_modal3()"
            v-if="!showspinner"
            >next></md-button
          >
        </md-dialog-actions>
        <div>
          <img class="logo-size" src="@/assets/logo.png" />
        </div>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",

  data: () => ({
    showDialog: true,
    session_key: "",
    idtype: "",
    modal: "",
    showspinner: false,
    Session: {},
  }),

  methods: {
    go_modal3() {
      this.showspinner = true;
      this.$router.push({
        name: "VerifyCapture",
        params: {
          session_key: this.session_key,
          idtype: this.idtype,
          modal: this.modal,
          session: this.Session,
        },
      });
    },
    onResize({ width, height }) {
      window.onResizeHandler(width, height);
    },
  },

  mounted() {
    this.session_key = this.$route.params.session_key;
    this.modal = this.$route.params.modal;
    this.idtype = this.$route.params.idtype;
    this.Session = this.$route.params.session;
    if (this.session_key == null) {
      const _this = this;
      this.$router.push({
        name: "HandleError",
        params: {
          session: _this.Session,
          type: "notSession",
        },
      });
    }
  },
};
</script> 

<style lang="scss" scoped>
.logo-size {
  width: 150px;
}
.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  background-color: #73c773;
  border-radius: 10px;
  padding-left: 100px;
  padding-right: 100px;
  color: white !important;
}

.md-dialog-actions {
  justify-content: center;
  padding: 8px !important;
}

.btn-element {
  margin: 1% !important;
  color: black !important;
  font-size: 12px;
}
ul {
  margin-top: 1rem !important;
  margin-bottom: 0rem !important;
}
li{
  margin-bottom:4px !important;
}
.md-dialog-modal-none {
  right: unset;
  bottom: unset;
  z-index: 1;
  ::v-deep .md-dialog-container {
    box-shadow: none;
    max-width: 100%;
  }
}

.md-dialog-modal {
  z-index: 1;
  ::v-deep .md-dialog-container {
    max-width: 500px;
    border-radius: 20px !important;
    border: 3px solid black;
  }
}
</style>